import { render, staticRenderFns } from "./SetupModules.vue?vue&type=template&id=764400ee&scoped=true&"
import script from "./SetupModules.vue?vue&type=script&lang=js&"
export * from "./SetupModules.vue?vue&type=script&lang=js&"
import style0 from "./SetupModules.vue?vue&type=style&index=0&id=764400ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764400ee",
  null
  
)

export default component.exports